import React from 'react';

export interface MobileParameterSectionProps {
	title: string;
	summary: string;
	isOpen: boolean;
	hasError?: boolean;
	onToggle: () => void;
	children: React.ReactNode;
}

export const MobileParameterSection = ({
	title, summary, isOpen, hasError, onToggle, children
}: MobileParameterSectionProps) => (
	<div className="flex flex-col">
		<div className={'rounded-2xl bg-tablz-med-gray-2 border ' + (hasError ? 'border-[#d92d20]' : 'border-tablz-med-gray-4')}>
			<button type="button" onClick={onToggle} className="w-full flex justify-between items-center px-4 py-4">
				<span className="font-poppins font-semibold text-lg text-tablz-text-white-1">{title}</span>
				<span className="font-poppins text-sm text-tablz-text-gray-1">{summary}</span>
			</button>
			{isOpen && <div className="px-4 pb-4">{children}</div>}
		</div>
	</div>
);
